import * as z from "zod";

const promptFixChangeSchema = z.discriminatedUnion("target", [
  z.object({
    /** The merchant text being fixed; "guidance" is kept for the wire. */
    target: z.literal("guidance"),
    /** Offsets of `before` in the text the fix was written for. */
    start: z.number().int(),
    end: z.number().int(),
    before: z.string(),
    highlightStart: z.number().int(),
    highlightEnd: z.number().int(),
    after: z.string(),
  }),
  z.object({
    target: z.literal("guideline"),
    /** The guideline to replace, exactly as saved; null adds a new one. */
    before: z.string().nullable(),
    after: z.string(),
  }),
  z.object({
    target: z.literal("voiceInstructions"),
    before: z.string(),
    after: z.string(),
  }),
  z.object({
    target: z.literal("knowledgeEdit"),
    articleId: z.string(),
    articleTitle: z.string(),
    before: z.string(),
    after: z.string(),
  }),
  z.object({
    target: z.literal("knowledgeCreate"),
    title: z.string(),
    after: z.string(),
  }),
]);

export type PromptFixChangeWire = z.infer<typeof promptFixChangeSchema>;

/** The changes a fix card offers for one issue in merchant text that goes into an agent's prompt. */
export const promptFixSchema = z.object({
  /** "one" when the changes are alternatives. */
  choose: z.enum(["one", "any"]),
  changes: z.array(promptFixChangeSchema),
});

export type PromptFixWire = z.infer<typeof promptFixSchema>;

export const promptFixIssueSchema = z.object({
  start: z.number().int(),
  end: z.number().int(),
  message: z.string(),
  kind: z.string().optional(),
});
